import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

/**
 * Server-verified admin route guard.
 * Local storage flags alone are NOT trusted — the JWT is validated
 * against /api/admin/verify before rendering the protected page.
 */
const RequireAdmin: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const [state, setState] = useState<'checking' | 'ok' | 'denied'>('checking');

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    const loggedIn = localStorage.getItem('adminLoggedIn');
    if (!token || loggedIn !== 'true') {
      setState('denied');
      return;
    }

    axios.get('/api/admin/verify', {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(() => setState('ok'))
      .catch(() => {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminLoggedIn');
        setState('denied');
      });
  }, []);

  if (state === 'checking') {
    return <div style={{ padding: '40px', textAlign: 'center' }}>Verifying session…</div>;
  }
  if (state === 'denied') {
    return <Navigate to="/admin" replace />;
  }
  return children;
};

export default RequireAdmin;
